import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Company,
  CompanyListItem,
  CompanyCreateRequest,
  CompanyUpdateRequest,
  PagedResult,
  SalesforceCompany,
} from '../../core';

export const CompaniesPageActions = createActionGroup({
  source: 'Companies Page',
  events: {
    'Load Companies': props<{ page?: number; pageSize?: number }>(),
    'Change Page': props<{ page: number }>(),
    'Change Page Size': props<{ pageSize: number }>(),
    'Search Companies': props<{ search: string }>(),
    Sort: props<{ field: string }>(),
  },
});

export const CompaniesAPIActions = createActionGroup({
  source: 'Companies API',
  events: {
    'Load Companies Success': props<{ result: PagedResult<CompanyListItem> }>(),
    'Load Companies Failure': props<{ error: string }>(),
  },
});

export const CompanyDetailPageActions = createActionGroup({
  source: 'Company Detail Page',
  events: {
    'Load Company': props<{ arNumber: string }>(),
    'Clear Current Company': emptyProps(),
  },
});

export const CompanyDetailAPIActions = createActionGroup({
  source: 'Company Detail API',
  events: {
    'Load Company Success': props<{ company: Company }>(),
    'Load Company Failure': props<{ error: string }>(),
    'Load Company Not Found': props<{ arNumber: string }>(),
  },
});

export const CompanyFormActions = createActionGroup({
  source: 'Company Form',
  events: {
    'Create Company': props<{ request: CompanyCreateRequest }>(),
    'Update Company': props<{
      arNumber: string;
      request: CompanyUpdateRequest;
    }>(),
    'Check AR Number Exists': props<{ arNumber: string }>(),
    'Search Salesforce': props<{ query: string }>(),
  },
});

export const CompanyFormAPIActions = createActionGroup({
  source: 'Company Form API',
  events: {
    'Create Company Success': props<{ company: Company }>(),
    'Create Company Failure': props<{ error: string }>(),
    'Update Company Success': props<{ company: Company }>(),
    'Update Company Failure': props<{ error: string }>(),
    'AR Number Exists': props<{ arNumber: string; exists: boolean }>(),
    'Salesforce Search Success': props<{ results: SalesforceCompany[] }>(),
    'Salesforce Search Failure': props<{ error: string }>(),
  },
});
